module.exports = __webpack_public_path__ + "img/seaux.75d7bfbc.jpg";